/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { introductionInquiryLogControllerFindAll } from '../fn/introduction-inquiry-log/introduction-inquiry-log-controller-find-all';
import { IntroductionInquiryLogControllerFindAll$Params } from '../fn/introduction-inquiry-log/introduction-inquiry-log-controller-find-all';
import { introductionInquiryLogControllerSearchOffset } from '../fn/introduction-inquiry-log/introduction-inquiry-log-controller-search-offset';
import { IntroductionInquiryLogControllerSearchOffset$Params } from '../fn/introduction-inquiry-log/introduction-inquiry-log-controller-search-offset';
import { IntroductionInquiryLogDto } from '../models/introduction-inquiry-log-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class IntroductionInquiryLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `introductionInquiryLogControllerFindAll()` */
  static readonly IntroductionInquiryLogControllerFindAllPath = '/api/introduction-inquiry-log';

  /**
   * 도입문의 로그 전체 조회.
   *
   * 도입문의 로그 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `introductionInquiryLogControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryLogControllerFindAll$Response(params?: IntroductionInquiryLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IntroductionInquiryLogDto>>> {
    return introductionInquiryLogControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 도입문의 로그 전체 조회.
   *
   * 도입문의 로그 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `introductionInquiryLogControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryLogControllerFindAll(params?: IntroductionInquiryLogControllerFindAll$Params, context?: HttpContext): Observable<Array<IntroductionInquiryLogDto>> {
    return this.introductionInquiryLogControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<IntroductionInquiryLogDto>>): Array<IntroductionInquiryLogDto> => r.body)
    );
  }

  /** Path part for operation `introductionInquiryLogControllerSearchOffset()` */
  static readonly IntroductionInquiryLogControllerSearchOffsetPath = '/api/introduction-inquiry-log/search/offset';

  /**
   * 도입문의 로그 오프셋 기반 조회.
   *
   * 도입문의 로그를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `introductionInquiryLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryLogControllerSearchOffset$Response(params: IntroductionInquiryLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return introductionInquiryLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 도입문의 로그 오프셋 기반 조회.
   *
   * 도입문의 로그를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `introductionInquiryLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryLogControllerSearchOffset(params: IntroductionInquiryLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.introductionInquiryLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

}
